import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { canActivateAuthRole } from './auth/auth-guard';
import { Role } from 'shared-lib';
import { RegisterComponent } from './register/register.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { LicensePlatesComponent } from './license-plates/license-plates.component';
import { RegisterLicensePlateComponent } from './license-plates/register-license-plate/register-license-plate.component';
import { canActivateJkuSso } from './jku-webshop/jku-sso-guard';
import { canActivateParkerHome } from './jku-webshop/jku-root-guard';
import { EasypassRedeemComponent } from './easypass/easypass-redeem.component';


import { ParkingActivityComponent } from './parking-activity/parking-activity.component';
import { EntitlementsComponent } from './entitlements/entitlements.component';


import { LegalComponent } from './legal/legal.component';
import { SiteComponent } from './site/site.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    // On the JKU hostname the root is the webshop, not the JJames parker home page.
    canActivate: [canActivateParkerHome]
  },
  {
    // A site's own payment page — the URL behind the QR on the site's printed signs. The home page's
    // guest lookup, limited to this parking space. Public: no guard, signed in or not.
    path: 'site/:parkingSpaceId',
    component: SiteComponent,
  },
  {
    path: 'legal',
    component: LegalComponent,
  },
  {
    path: 'terms',
    redirectTo: 'legal',
    pathMatch: 'full'
  },
  {
    path: 'privacy',
    redirectTo: 'legal',
    pathMatch: 'full'
  },
  {
    path: 'activity',
    component: ParkingActivityComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.RegisteredParker }
  },
  {
    path: 'entitlements',
    component: EntitlementsComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.RegisteredParker }
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'my-account',
    component: MyAccountComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.RegisteredParker }
  },
  {
    path: 'license-plates',
    component: LicensePlatesComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.RegisteredParker }
  },
  {
    path: 'license-plates/register',
    component: RegisterLicensePlateComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.RegisteredParker }
  },
  {
    path: 'JKU-webshop',
    canActivate: [canActivateJkuSso],
    loadChildren: () => import('./jku-webshop/jku-webshop.routes').then(m => m.JKU_WEBSHOP_ROUTES)
  },
  {
    path: 'easypass/redeem/:token',
    component: EasypassRedeemComponent,
  }
];
